export default __webpack_public_path__ + "static/igltalogo-1a7f56e319a87603e76631abadf0e5c8.png";